import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import PropTypes from 'prop-types';
import {
  DialogActionButton,
  DialogActions,
  DialogCancelButton,
  DialogHeader,
} from '@/components/common/CustomDialog';
import Loader from '@/components/common/Loader';
import SearchInput from '@/components/common/SearchInput';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import translate from '@/lib/intl/translate';
import ConstituentPropType from '@/lib/types/ConstituentPropType';
import useConstituentWithTeamMembers from '../hooks/useConstituentWithTeamMembers';
import ConstituentCardTeamMemberRowItem from './ConstituentCardTeamMemberRowItem';

function ConstituentCardItemActionsAssign({ constituent, header, onClose }) {
  const {
    teamMemberFilter,
    setTeamMemberFilter,
    filterTeamMembers,
    assignedTeamMembers,
    isTeamMembersLoading,
    setPrimary,
    setSecondary,
  } = useConstituentWithTeamMembers(constituent);
  const { isBusy: isUpdating, updateConstituent } = useConstituent(
    constituent.constituentId,
    1,
  );

  const handleSubmit = () => {
    const formattedData = assignedTeamMembers
      .filter((member) => member.isPrimary || member.isSecondary)
      .map((member) => ({
        userId: member.userId,
        primary: !!member.isPrimary,
        displayName: member.displayName,
      }));

    updateConstituent({ developers: formattedData });

    onClose();
  };

  const renderTeamMembers = () =>
    filterTeamMembers(assignedTeamMembers).map((teamMember) => (
      <ConstituentCardTeamMemberRowItem
        key={teamMember?.userId}
        teamMemberId={teamMember?.userId}
        title={teamMember?.displayName}
        primary={teamMember?.isPrimary}
        setPrimary={setPrimary}
        secondary={teamMember?.isSecondary}
        setSecondary={setSecondary}
      />
    ));

  return (
    <div className="flex flex-col">
      <DialogHeader
        headerText={translate('DONOR_CARD_ACTION_ASSIGN')}
        onClose={onClose}
      />
      <DialogContent dividers className="p-0">
        {header}
        <div className="p-4">
          <SearchInput
            onChange={setTeamMemberFilter}
            placeholder={translate('DONOR_CARD_ACTION_ASSIGN_SEARCH')}
            value={teamMemberFilter}
          />
        </div>
        <div className="flex max-h-[360px] min-h-[70px] flex-col items-center overflow-y-auto">
          {!isTeamMembersLoading ? (
            renderTeamMembers()
          ) : (
            <div className="mt-4 h-[70px]">
              <Loader />
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <DialogActionButton showLoader={isUpdating} onClick={handleSubmit}>
          {translate('UPDATE')}
        </DialogActionButton>
        <DialogCancelButton
          data-testid="constituent-card-item-actions-assign-close"
          onClick={onClose}
        />
      </DialogActions>
    </div>
  );
}

ConstituentCardItemActionsAssign.propTypes = {
  constituent: ConstituentPropType,
  header: PropTypes.node,
  onClose: PropTypes.func,
};

ConstituentCardItemActionsAssign.defaultProps = {
  constituent: {},
  header: null,
  onClose: () => {},
};

export default ConstituentCardItemActionsAssign;
